export default defineNuxtRouteMiddleware(async (to, from) => {
  // Check device type from Tauri first (more reliable than DB setting)
  try {
    const { invoke } = await import('@tauri-apps/api/core')
    const deviceType = await invoke('get_device_type')

    if (deviceType === 'kds') {
      console.log('[kds-only] Device type is kds, allowing access to /kds')
      return // Allow access to /kds page
    }
  } catch (err) {
    // Not in Tauri or no device ID, fall back to database setting
  }

  const { getPosSetting } = usePosDatabase()

  const isKdsMode = await getPosSetting('isKdsMode')

  if (isKdsMode !== '1') {
    console.log('[kds-only] Not in KDS mode, redirecting to /orders')
    return navigateTo('/orders')
  }
})
